// Shared formatting for Product Pricing.

export const SYMBOL = { USD: '$', ILS: '₪', NIS: '₪', EUR: '€', GBP: '£' };
export const CURRENCIES = ['USD', 'ILS', 'NIS', 'EUR', 'GBP'];

// What everything falls back to: prices were USD-only before currencies were
// selectable, and USD is still the house currency.
export const DEFAULT_CURRENCY = 'USD';

// ILS and NIS are listed as separate choices by request — they share the ₪
// sign, so a price is always identified by its CODE rather than its symbol
// wherever the two could be confused.
export const CURRENCY_LABEL = { USD: 'USD', ILS: 'ILS', NIS: 'NIS', EUR: 'EUR', GBP: 'GBP' };

// The currency a reseller's price is stored in — their own if they have one,
// otherwise the sub-product's base currency. Never blank.
export const priceCurrency = (row) => row?.resellerCurrency || row?.currency || DEFAULT_CURRENCY;

// Prices are per-unit and small (1.25, 2.6, 3.5), so they show to 2 decimals and
// keep trailing zeros — "2.50" reads as a price, "2.5" reads as a quantity.
//
// A null price means "not configured" and is NEVER rendered as 0: the caller
// gets null back and is expected to print the "Not configured" state instead.
export function money(n, currency = 'USD') {
  if (n === null || n === undefined || n === '') return null;
  return `${SYMBOL[currency] || '$'}${Number(n).toFixed(2)}`;
}

// Currencies that share a symbol with another entry on the list: a figure in ₪
// says nothing about whether it is ILS or NIS, so those are always printed with
// their code behind them. The rest stand on their symbol alone.
const AMBIGUOUS = ['ILS', 'NIS'];

export function moneyLabel(n, currency) {
  const m = money(n, currency);
  if (m === null) return null;
  return AMBIGUOUS.includes(currency) ? `${m} ${currency}` : m;
}

export const STATUSES = ['Available', 'Out of Stock', 'Pre-Order', 'Discontinued'];

export const STATUS_TONE = {
  Available: 'up',
  'Out of Stock': 'down',
  'Pre-Order': 'brand',
  Discontinued: 'neutral',
};
